import {take, fork, select, put} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import {EmergencyContact, persistenceStates} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';
import * as applicationActionTypes from '../../application/applicationActionTypes';
import modalIds from '../../modalIds';
import errorTypes from '../../application/errorTypes';

const updateCPContactDataFlow = function* updateCPContactDataFlow() {
    const {serviceManager} = yield select(state => state.application);
    const partnerManagementService = serviceManager.loadService('partnerManagementService');
    let shouldWaitForAction = true;
    let shouldRetryUpdate = false;
    let chosenModalOption;
    let payloadContent;

    while (true) {
        if (shouldWaitForAction) {
            const {payload} = yield take(contractPartnerActionTypes.INITIATE_UPDATE_CP_CONTACT_DATA_FLOW);
            payloadContent = payload;
            const {contactDataId, isAdditional = false} = payload;

            yield* openModal(modalIds.CONTRACT_PARTNER_CONTACT_DATA, {
                contactDataId: `${contactDataId}`,
                ...(isAdditional && {isAdditional: `${!!isAdditional}`}),
            });

            chosenModalOption = yield take([
                contractPartnerActionTypes.CONFIRM_UPDATE_CP_CONTACT_DATA,
                contractPartnerActionTypes.DECLINE_UPDATE_CP_CONTACT_DATA,
            ]);
        }

        const {isAdditional = false, contactDataId} = payloadContent;

        if ((chosenModalOption
            && chosenModalOption.type === contractPartnerActionTypes.CONFIRM_UPDATE_CP_CONTACT_DATA)
            || shouldRetryUpdate
        ) {
            const {contactData} = chosenModalOption.payload;
            const {retryActionPersistenceState} = yield select(state => state.application);

            yield fork(
                fetchRequest,
                contractPartnerActionTypes.UPDATE_CP_CONTACT_DATA_REQUEST,
                partnerManagementService.updateCPContactData,
                {
                    contactDataDTO: EmergencyContact.objectToPatchDTO(contactData),
                    contactDataId: payloadContent.contactDataId,
                },
            );

            const responseAction = yield take([
                contractPartnerActionTypes.UPDATE_CP_CONTACT_DATA_REQUEST_SUCCEEDED,
                contractPartnerActionTypes.UPDATE_CP_CONTACT_DATA_REQUEST_FAILED,
            ]);

            if (retryActionPersistenceState === persistenceStates.PENDING) {
                yield put({
                    type: applicationActionTypes.SET_RETRY_ACTION_PERSISTENCE_STATE,
                    payload: {persistenceState: persistenceStates.READY},
                });
            }

            if (!responseAction.error) {
                const {response} = responseAction.payload;
                const {contactDataDTO} = response;

                yield put({
                    type: contractPartnerActionTypes.STORE_CP_CONTACT_DATA,
                    payload: {contactDataDTO, contractPartnerId: payloadContent.contractPartnerId},
                });

                if (shouldRetryUpdate) {
                    shouldRetryUpdate = false;
                    shouldWaitForAction = true;
                    chosenModalOption = null;
                    payloadContent = null;
                    yield* closeModal(modalIds.ERROR_MESSAGE_MODAL, {errorType: ''});
                }
            }

            if (responseAction.error) {
                yield* closeModal(modalIds.CONTRACT_PARTNER_CONTACT_DATA, {
                    contactDataId: `${contactDataId}`,
                    ...(isAdditional && {isAdditional: `${!!isAdditional}`}),
                });

                yield* openModal(modalIds.ERROR_MESSAGE_MODAL, {errorType: errorTypes.EDIT_CP_CONTACT_FAILED});

                const nextAction = yield take([
                    contractPartnerActionTypes.RETRY_CP_CONTACT_DATA_EDIT,
                    contractPartnerActionTypes.CANCEL_CP_CONTACT_DATA_EDIT,
                ]);

                if (nextAction.type === contractPartnerActionTypes.RETRY_CP_CONTACT_DATA_EDIT) {
                    shouldRetryUpdate = true;
                    shouldWaitForAction = false;
                    if (retryActionPersistenceState !== persistenceStates.PENDING) {
                        yield put({
                            type: applicationActionTypes.SET_RETRY_ACTION_PERSISTENCE_STATE,
                            payload: {persistenceState: persistenceStates.PENDING},
                        });
                    }
                    continue;
                }

                if (nextAction.type === contractPartnerActionTypes.CANCEL_CP_CONTACT_DATA_EDIT) {
                    shouldRetryUpdate = false;
                    shouldWaitForAction = true;
                    chosenModalOption = null;
                    payloadContent = null;
                    yield* closeModal(modalIds.ERROR_MESSAGE_MODAL, {errorType: ''});
                    continue;
                }
            }
        }

        yield* closeModal(modalIds.CONTRACT_PARTNER_CONTACT_DATA, {
            contactDataId: `${contactDataId}`,
            ...(isAdditional && {isAdditional: `${!!isAdditional}`}),
        });
    }
};

export default updateCPContactDataFlow;
